import { render, staticRenderFns } from "./Detail-Equipment.vue?vue&type=template&id=408046fa"
import script from "./Detail-Equipment.vue?vue&type=script&lang=js"
export * from "./Detail-Equipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports